import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faArrowRight,
  faEllipsisVertical,
} from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import i18next from "i18next";

function Pagination({ children }) {
  const ref = useRef(null);

  return (
    <div className="Pagination relative">
      <ul className="pagination">
        <li type="button" className="previous disabled" disabled="">
          <FontAwesomeIcon icon={faArrowLeft} fontSize={20} />
        </li>
        <li className="page-item page-active">
          <span role="button" className="page-link">
            1
          </span>
        </li>
        <li type="button" className="next disabled" disabled="">
          <FontAwesomeIcon icon={faArrowRight} fontSize={20} />
        </li>
      </ul>
    </div>
  );
}

export default Pagination;
